"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferActivityLogDtoActivityTypeEnum = void 0;
exports.instanceOfOfferActivityLogDto = instanceOfOfferActivityLogDto;
exports.OfferActivityLogDtoFromJSON = OfferActivityLogDtoFromJSON;
exports.OfferActivityLogDtoFromJSONTyped = OfferActivityLogDtoFromJSONTyped;
exports.OfferActivityLogDtoToJSON = OfferActivityLogDtoToJSON;
exports.OfferActivityLogDtoToJSONTyped = OfferActivityLogDtoToJSONTyped;
var PerformedByDto_1 = require("./PerformedByDto");
/**
 * @export
 */
exports.OfferActivityLogDtoActivityTypeEnum = {
    OfferCreated: 'offer_created',
    OfferSubmitted: 'offer_submitted',
    OfferAccepted: 'offer_accepted',
    OfferRejected: 'offer_rejected',
    OfferCountered: 'offer_countered',
    OfferReserved: 'offer_reserved',
    OfferWithdrawn: 'offer_withdrawn',
    OfferExpired: 'offer_expired',
    CounterOfferCreated: 'counter_offer_created',
    CounterOfferAccepted: 'counter_offer_accepted',
    CounterOfferRejected: 'counter_offer_rejected',
    DepositReceived: 'deposit_received',
    DepositConfirmed: 'deposit_confirmed',
    PropertySold: 'property_sold',
    ContractSigned: 'contract_signed',
    ContractDeclined: 'contract_declined',
    ContractCancelled: 'contract_cancelled',
    StatusChanged: 'status_changed',
    AgentApproved: 'agent_approved',
    AgentRejected: 'agent_rejected'
};
/**
 * Check if a given object implements the OfferActivityLogDto interface.
 */
function instanceOfOfferActivityLogDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('offerId' in value) || value['offerId'] === undefined)
        return false;
    if (!('activityType' in value) || value['activityType'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function OfferActivityLogDtoFromJSON(json) {
    return OfferActivityLogDtoFromJSONTyped(json, false);
}
function OfferActivityLogDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'offerId': json['offerId'],
        'activityType': json['activityType'],
        'title': json['title'],
        'description': json['description'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'performedBy': json['performedBy'] == null ? undefined : (0, PerformedByDto_1.PerformedByDtoFromJSON)(json['performedBy']),
        'previousStatus': json['previousStatus'] == null ? undefined : json['previousStatus'],
        'newStatus': json['newStatus'] == null ? undefined : json['newStatus'],
        'createdAt': json['createdAt'],
    };
}
function OfferActivityLogDtoToJSON(json) {
    return OfferActivityLogDtoToJSONTyped(json, false);
}
function OfferActivityLogDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'offerId': value['offerId'],
        'activityType': value['activityType'],
        'title': value['title'],
        'description': value['description'],
        'metadata': value['metadata'],
        'performedBy': (0, PerformedByDto_1.PerformedByDtoToJSON)(value['performedBy']),
        'previousStatus': value['previousStatus'],
        'newStatus': value['newStatus'],
        'createdAt': value['createdAt'],
    };
}
